/* tslint:disable */
/* eslint-disable */
/**
 * Solid Slate
 * Booking, made easy
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Basic serializer to pass CustomUser details to the front end.
 * Extend with any fields your app needs.
 * @export
 * @interface CustomUser
 */
export interface CustomUser {
    /**
     * 
     * @type {number}
     * @memberof CustomUser
     */
    readonly id: number;
    /**
     * 
     * @type {string}
     * @memberof CustomUser
     */
    firstName?: string;
    /**
     * 
     * @type {string}
     * @memberof CustomUser
     */
    lastName?: string;
    /**
     * 
     * @type {string}
     * @memberof CustomUser
     */
    email?: string;
    /**
     * Required. 150 characters or fewer. Letters, digits and @/./+/-/_ only.
     * @type {string}
     * @memberof CustomUser
     */
    username: string;
    /**
     * 
     * @type {string}
     * @memberof CustomUser
     */
    readonly avatarUrl: string;
    /**
     * 
     * @type {string}
     * @memberof CustomUser
     */
    readonly getDisplayName: string;
    /**
     * Designates whether this user should be treated as active. Unselect this instead of deleting accounts.
     * @type {boolean}
     * @memberof CustomUser
     */
    isActive?: boolean;
    /**
     * Designates that this user has all permissions without explicitly assigning them.
     * @type {boolean}
     * @memberof CustomUser
     */
    isSuperuser?: boolean;
    /**
     * Designates whether the user can log into this admin site.
     * @type {boolean}
     * @memberof CustomUser
     */
    isStaff?: boolean;
    /**
     * Method to properly serialize the has_usable_password method
     * @type {boolean}
     * @memberof CustomUser
     */
    readonly hasUsablePassword: boolean;
    /**
     * 
     * @type {string}
     * @memberof CustomUser
     */
    language?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CustomUser
     */
    timezone?: string;
}

/**
 * Check if a given object implements the CustomUser interface.
 */
export function instanceOfCustomUser(value: object): value is CustomUser {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('username' in value) || value['username'] === undefined) return false;
    if (!('avatarUrl' in value) || value['avatarUrl'] === undefined) return false;
    if (!('getDisplayName' in value) || value['getDisplayName'] === undefined) return false;
    if (!('hasUsablePassword' in value) || value['hasUsablePassword'] === undefined) return false;
    return true;
}

export function CustomUserFromJSON(json: any): CustomUser {
    return CustomUserFromJSONTyped(json, false);
}

export function CustomUserFromJSONTyped(json: any, ignoreDiscriminator: boolean): CustomUser {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'firstName': json['first_name'] == null ? undefined : json['first_name'],
        'lastName': json['last_name'] == null ? undefined : json['last_name'],
        'email': json['email'] == null ? undefined : json['email'],
        'username': json['username'],
        'avatarUrl': json['avatar_url'],
        'getDisplayName': json['get_display_name'],
        'isActive': json['is_active'] == null ? undefined : json['is_active'],
        'isSuperuser': json['is_superuser'] == null ? undefined : json['is_superuser'],
        'isStaff': json['is_staff'] == null ? undefined : json['is_staff'],
        'hasUsablePassword': json['has_usable_password'],
        'language': json['language'] == null ? undefined : json['language'],
        'timezone': json['timezone'] == null ? undefined : json['timezone'],
    };
}

  export function CustomUserToJSON(json: any): CustomUser {
      return CustomUserToJSONTyped(json, false);
  }

  export function CustomUserToJSONTyped(value?: Omit<CustomUser, 'id'|'avatar_url'|'get_display_name'|'has_usable_password'> | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'first_name': value['firstName'],
        'last_name': value['lastName'],
        'email': value['email'],
        'username': value['username'],
        'is_active': value['isActive'],
        'is_superuser': value['isSuperuser'],
        'is_staff': value['isStaff'],
        'language': value['language'],
        'timezone': value['timezone'],
    };
}

